




import { createApp } from 'contentAIApp/vue3'
import Modal from 'contentAIApp/Modal';
import { useEmitter } from '../../composition/useEmitter'
import { defineComponent } from '@vue/composition-api'
import { useAppContext } from '../../composition/useAppContext'
import { trackPendoEvent } from '../../../util/helper'
import { now } from 'moment';

let contentAIModalComponent: any = {}

export default defineComponent({
watch: {
'$route': function (id) {
  this.mountContentAIModal()
},
},
mounted() {
this.mountContentAIModal()
},
methods: {
async mountContentAIModal() {
  if (contentAIModalComponent.unmount) contentAIModalComponent?.unmount()
  const route = this.$route
  const router = this.$router
  const emitter = useEmitter()
  const user = this.$store.getters['user/get']
  const location = await this.$store.getters['locations/getCurrentLocation']
  const store = this.$store
  const userSpecificLanguage = store.state.user?.user?.platformLanguage
  const locationSpecificLanguage = location?.locale_settings?.platform
  const locale = userSpecificLanguage || locationSpecificLanguage || 'en-US'


  const { mountAppContext } = useAppContext()
  contentAIModalComponent = createApp(Modal, {
    route,
    router,
    emitter,
    user,
    store,
    locale
  });
  mountAppContext({ contentAIApp: contentAIModalComponent }) 
  contentAIModalComponent.mount(`#content-ai-modals`);
  emitter.on('pendo-track-event', (pendoData: any)=> {
    if (pendoData?.event) trackPendoEvent(pendoData?.event, pendoData?.properties)
  });
},
}
})
